

document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    updateFreeShippingBox('.advanced-order .extras-wrap');
    $('.advanced-order .h1:not(.advanced-order-suggestion)').text(translation('vKosiku'));
    $('.advanced-order .h1.advanced-order-suggestion').text(translation('doporucujemePrikoupit'));
    $('#colorbox').addClass('advancedContent');

    $.colorbox.resize();
    $("#cboxContent #products").slick({
        slidesToShow: 4.5,
        slidesToScroll: 1,
        infinite: false,
        autoplay: false,
        dots: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3.5
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2.5
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1.8
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 1.5
                }
            }
        ]
    });


    if (lastProductData) {
        fillOrderPopup(lastProductData);
        if ($('.h1.advanced-order-suggestion').length) {

        }
    }
    else {
        console.log("error bez dat");
    }
})

let lastProductData = null;

function syncColorBoxOpenState() {
    const isColorboxOpen = $('#cboxOverlay:visible').length > 0 || $('#colorbox:visible').length > 0;
    $('body').toggleClass('colorBoxOpen', isColorboxOpen);
}

$(document)
    .on('cbox_open cbox_complete', syncColorBoxOpenState)
    .on('cbox_closed cbox_cleanup', syncColorBoxOpenState);





// DETAIL PRODUKTU
$('.p-detail-inner').on('submit', 'form.pr-action', function (e) {
    const $product = $('.product-top');
    lastProductData = {
        image: $product.find('.p-main-image img').attr('src'),
        price: $product.find('.p-final-price-wrapper').html(),
        priceSave: $product.find('.flag.flag-discount .price-save').text(),
        amount: parseInt($(this).find('input[name="amount"]').val()) || 1,
    };
});








function fillOrderPopup(productData) {
    const $title = $(".h2[data-testid='textPopupProductName']");

    if (!$title.parent().hasClass("textWrapper")) {
        $title.wrap('<div class="textWrapper"></div>');
        if (!$('.textWrapper').parent().hasClass("productWrapper")) {
            $('.textWrapper').wrap('<div class="productWrapper"></div>');
        }
    }
    if ($('.h2[data-testid="textPopupProductName"] span:not(.product-appendix)').length) {
        const $el = $('.h2[data-testid="textPopupProductName"] span:not(.product-appendix)');
        const text = $el.text();

        const parts = text.split(', ');

        const result = parts.map(part => {
            const idx = part.indexOf(':');

            if (idx !== -1) {
                const label = part.substring(0, idx + 1); // včetně :
                const rest = part.substring(idx + 1);

                return `<b>${label}</b>${rest}`;
            }

            return part;
        }).join(' ');

        $el.html(result);
    }
    const $wrapper = $('.productWrapper').first();
    $wrapper.prepend('<img src="' + productData.image + '" alt="Product Image">');
    //   $wrapper.find(".textWrapper").append('<div class="amount">' + productData.amount + ' x</div>');
    $wrapper.find(".textWrapper").append('<div class="price">' +
        productData.price +
        (productData.priceSave ? '<div class="priceSave">' + productData.priceSave + '</div>' : '') +
        '</div>');
    $wrapper.find(".textWrapper").append($wrapper.find(".h2[data-testid='textPopupProductName'] span:not(.product-appendix)").clone());
    $.colorbox.resize();
}









const test = false;
$('html').on('click', '.remove-item', function (e) {

    if (test) {
        return;
    }
    e.preventDefault();
    e.stopImmediatePropagation()
    const $form = $(this);
    const itemId = $form.closest('form').find('input[name="itemId"]').attr('value');
    openRemoveConfirm($form, itemId);

});
//}

function openRemoveConfirm($form, itemId) {
    $.colorbox({
        html: `
<div class="cartRemoveConfirm">
    <h3>Opravdu chcete produkt odebrat? Možná už nebude.</h3>
  
    <div class="buttons">
        <button class="btn btn-alert confirmRemove" data-id="${itemId}">Odebrat</button>
        <button class="btn btn-conversion cancelRemove">Ponechat</button>
    </div>
</div>
`,
        width: '90%', maxWidth: '608px'
    });
}

let confirmedRemove = false;

$(document).on('click', '.confirmRemove', function () {
    const itemId = $(this).attr('data-id');
    confirmedRemove = true; // flag pro potvrzení
    if (typeof shoptet !== 'undefined' && shoptet.cartShared) {
        shoptet.cartShared.removeFromCart({ itemId: itemId });
    }
    $.colorbox.close();
});

$(document).on('click', '.cancelRemove', function () {
    confirmedRemove = false; // zrušit flag
    $.colorbox.close();
}); 